import React from 'react';
import classNames from 'classnames';

interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  className?: string;
  size?: 'sm' | 'md';
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, size = 'sm', ...props }, ref) => (
    <span className="relative inline-block align-middle">
      <input
        ref={ref}
        type="checkbox"
        className={classNames(
          size === 'md' ? 'size-8' : 'size-6',
          'appearance-none rounded-[4px] border border-line !p-[2px] outline-line hover:border-primary',
          // checked state: inner bg-primary with 4px padding
          'checked:bg-transparent checked:border-line checked:after:mx-auto checked:after:my-auto checked:after:block checked:after:h-full checked:after:w-full checked:after:scale-90 checked:after:rounded-[2px] checked:after:bg-primary checked:after:transition-all checked:after:duration-150 checked:after:content-[""]',
          // disabled state
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-line',
          'relative cursor-pointer',
          'peer',
          className
        )}
        style={
          {
            // Ensure the pseudo-element is sized correctly
            // The actual sizing is handled by Tailwind classes above
          }
        }
        {...props}
      />
      {/* Custom SVG checkmark, shown only when checked */}
      <span
        className={classNames(
          'pointer-events-none absolute left-0 top-0 flex items-center justify-center transition-opacity duration-150',
          size === 'md' ? 'h-8 w-8' : 'h-6 w-6',
          'opacity-0 peer-checked:opacity-100 peer-disabled:opacity-50'
        )}
        style={{ pointerEvents: 'none' }}
        aria-hidden="true"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size === 'md' ? 16 : 12}
          height={size === 'md' ? 16 : 12}
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.16669 10.2333L11.5 2.66666L13.3334 3.70012L7.83443 13.3333L2.66669 9.44175L3.83374 7.79603L7.16669 10.2333Z"
            fill="white"
          />
        </svg>
      </span>
    </span>
  )
);

Checkbox.displayName = 'Checkbox';
Checkbox.displayName = 'Checkbox';
